var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('div',[_c('v-btn',{staticStyle:{"margin-right":"140px"},attrs:{"small":"","color":"primary"},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-eye-outline")]),_vm._v(" عرض الطلب الذى تم دمجه ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }